import React from 'react';
import { PatternBase, strokeWidth } from './PatternBase';
import { LinesForeward } from './StripesForewardPattern';
import { LinesBackward } from './StripesBackwardPattern';

const Lines = () => {
	return (
		<React.Fragment>
			<LinesForeward />
			<LinesBackward />
		</React.Fragment>
	);
};

export const CrossHatchThinPattern = ({
	foregroundColor,
	backgroundColor,
	id,
	...restProps
}) => {
	return (
		<PatternBase id={id} backgroundColor={backgroundColor} {...restProps}>
			<g stroke={foregroundColor} strokeWidth={strokeWidth / 2}>
				<Lines />
			</g>
		</PatternBase>
	);
};

export const CrossHatchThickPattern = ({
	foregroundColor,
	backgroundColor,
	id,
	...restProps
}) => {
	return (
		<PatternBase id={id} backgroundColor={foregroundColor} {...restProps}>
			<g stroke={backgroundColor} strokeWidth={strokeWidth / 2}>
				<Lines />
			</g>
		</PatternBase>
	);
};
